interface FlagsProps {
  onNavigate: (to: string) => void;
}

interface GameEntry {
  slug: string;
  name: string;
  blurb: string;
  ready: boolean;
}

const GAMES: readonly GameEntry[] = [
  {
    slug: "flashcards",
    name: "Flash cards (letter)",
    blurb: "See a flag, name the letter or digit. 6-way multiple choice with rolling hit-rate stats.",
    ready: true,
  },
  {
    slug: "meanings",
    name: "Flash cards (flag → meaning)",
    blurb: "See a flag, pick its operational meaning when flown alone (Oscar = man overboard, etc). Covers IRPCS / ICS Volume I single-flag signals.",
    ready: true,
  },
  {
    slug: "reverse",
    name: "Flash cards (meaning → flag)",
    blurb: "See the meaning, pick the flag. Reverse direction of the meanings drill — same pool of single-flag signals.",
    ready: true,
  },
  {
    slug: "combos",
    name: "Two-flag combinations",
    blurb: "Hoists of two flags carry composite meanings — NC = distress, AB = need a tug urgently, AC = abandoning my vessel. Tap the meaning.",
    ready: true,
  },
  {
    slug: "combos-reverse",
    name: "Two-flag combinations (reverse)",
    blurb: "See the meaning, pick the hoist. Reverse direction of the combos drill — same pool of two-flag signals.",
    ready: true,
  },
  {
    slug: "translate",
    name: "Translate",
    blurb: "Type a message — the flag hoist appears below. Hide the text and show the phone for someone else to decode.",
    ready: true,
  },
];

export function Flags({ onNavigate }: FlagsProps) {
  return (
    <>
      <p className="muted">
        International Code of Signals maritime flags. A–Z each has a meaning
        when flown alone (e.g. <strong>Oscar</strong> = man overboard).
        0–9 are tapered numeric pennants used for course / bearing / time
        signals. The full alphabet + meanings live on the Reference tab;
        pick a drill below to test your recall.
      </p>

      <h2 style={{ marginTop: 24 }}>Games</h2>
      {GAMES.map((g) => (
        <div key={g.slug} className="card">
          <h3 style={{ marginBottom: 4 }}>{g.name}</h3>
          <p className="small muted" style={{ marginBottom: 12 }}>
            {g.blurb}
          </p>
          <button
            onClick={() => onNavigate(`/play/flags/${g.slug}`)}
            className="secondary"
          >
            Play
          </button>
        </div>
      ))}
    </>
  );
}
